import React, { useEffect } from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="terms-page">
            <div className="container">
                <h1 className="terms-title">Terms & Conditions – Growing Fields Organics</h1>

                <div className="terms-content">
                    <section className="terms-section">
                        <h2>1. Introduction</h2>
                        <p>
                            Welcome to Growing Fields Organics. By accessing or using our website, products, or services, you agree to be bound by these Terms and Conditions. Please read them carefully before using our website.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>2. Product Information</h2>
                        <p>
                            All product details, descriptions, and images on this website are provided for general information purposes. As our products are natural and organic, slight variations in color, texture, or appearance may occur.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>3. Use of Products</h2>
                        <p>
                            Our products are intended for agricultural, gardening, and soil improvement purposes only. Results may vary depending on soil condition, climate, crop type, and method of use. Growing Fields Organics does not guarantee specific results or yields.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>4. Orders and Availability</h2>
                        <p>
                            All orders are subject to product availability. We reserve the right to limit, modify, or cancel orders and to discontinue any product without prior notice.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>5. Pricing and Payments</h2>
                        <p>
                            Prices listed on the website may change without notice. Payments must be completed through approved payment gateways. Growing Fields Organics is not responsible for payment failures or delays caused by third-party payment service providers.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>6. Shipping and Delivery</h2>
                        <p>
                            Delivery timelines are estimates and may vary due to location, logistics, weather conditions, or other unforeseen factors. Delays in delivery do not entitle customers to compensation unless explicitly stated.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>7. Returns and Refunds</h2>
                        <p>
                            Due to the nature of organic products, returns and refunds may be limited. Any issues related to damaged or incorrect products must be reported within the specified time after delivery. All refund or replacement decisions are made at the discretion of Growing Fields Organics.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>8. Product Storage</h2>
                        <p>
                            Customers are responsible for proper storage of products after delivery. Growing Fields Organics is not liable for quality issues resulting from improper storage or handling.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>9. Intellectual Property</h2>
                        <p>
                            All website content, including text, images, logos, and designs, is the property of Growing Fields Organics and may not be copied, reproduced, or used without prior written permission.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>10. Limitation of Liability</h2>
                        <p>
                            Growing Fields Organics shall not be liable for any direct, indirect, incidental, or consequential damages arising from the use of our products or website.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>11. Third-Party Links</h2>
                        <p>
                            Our website may contain links to third-party websites. Growing Fields Organics does not control or endorse the content or practices of these external websites.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>12. User Conduct</h2>
                        <p>
                            Users agree not to misuse the website, submit false information, or engage in any activity that may harm the website, business operations, or violate applicable laws.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>13. Changes to Terms</h2>
                        <p>
                            Growing Fields Organics reserves the right to update or modify these Terms and Conditions at any time. Continued use of the website indicates acceptance of the updated terms.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>14. Governing Law</h2>
                        <p>
                            These Terms and Conditions are governed by and interpreted in accordance with the laws of India.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>15. Contact Information</h2>
                        <p>
                            For any questions regarding these Terms and Conditions, please contact us through the details provided on our website.
                        </p>
                    </section>

                    <section className="terms-section last-updated">
                        <p><strong>Last updated: January 2026</strong></p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;
